import { render, staticRenderFns } from "./today-hot.vue?vue&type=template&id=bc9a7a70&scoped=true&"
import script from "./today-hot.vue?vue&type=script&lang=js&"
export * from "./today-hot.vue?vue&type=script&lang=js&"
import style0 from "./today-hot.vue?vue&type=style&index=0&id=bc9a7a70&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9a7a70",
  null
  
)

export default component.exports